export default __webpack_public_path__ + "static/media/BF7BF4E2-318C-4A03-9E1D-31C2D1E4C74B_1_105_c.6d38da86.jpeg";